import { render } from "./ListeCommandePage.vue?vue&type=template&id=f5487280&ts=true"
import script from "./ListeCommandePage.vue?vue&type=script&lang=ts"
export * from "./ListeCommandePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__